import { render, staticRenderFns } from "./materialTable.vue?vue&type=template&id=6872e86e&"
import script from "./materialTable.vue?vue&type=script&lang=js&"
export * from "./materialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports